import { css } from '@microsoft/fast-element';
import { mixinRobotoRegular } from '../../../styles';

export const SefAgreementRequiredStyles = css`
  .sef-group {
    display: flex;
    flex-direction: row;
    float: right;
    position: absolute;
    top: 15px;
    right: 25px;
    z-index: 1;
    align-items: center;
  }

  .sef-group label {
    color: var(--white-smoke);
    margin-bottom: 8px;
    box-sizing: border-box;
    ${mixinRobotoRegular}
    font-size: 13px;
    margin-left: 8px;
    margin-top: 4px;
    align-self: center;
    margin: 0px 8px;
  }

  .countNumber {
    background-color: rgba(249, 100, 77, 0.3);
    border: 1px solid #f9644d;
    border-radius: 25px;
    width: 23px;
    height: 23px;
    line-height: 23px;
    margin-left: 10px;
    color: #fff;
    font-size: 13px;
    text-align: center;
  }
`;
